module.exports = __webpack_public_path__ + "img/emo_56.3e190ae7.png";